import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getRequest } from '../../../helpers/request'
import { appApi } from '../../../utils/endpoints/appApi'
import { clearAll, onDeleteLetter, setErrorMessageUser, setLoadingUser, showDeleteConfirmationFunc } from '../../../config/redux/slice/appSlice'
import { Spinner } from '../../components'

export default function DeleteDigitalLetter({adjective, callBackFunc=null, email, subject, url}) {
    const dispatch = useDispatch()
    const {
        userLoading,
        userErrorMsg,
    } = useSelector((state) => state.app)
    const {
        token
    } = useSelector((state) => state.authData)

    const closeModal = () => {
        dispatch(clearAll({}))
        dispatch(showDeleteConfirmationFunc({ modal: false }));
    };

    const deleteLetter = async () =>{
        dispatch(clearAll({}))
        const res = await getRequest(
        token,
        `${url}`,
        {},
        dispatch,
        setLoadingUser,
        "",
        setErrorMessageUser
      )
      if(res!= undefined && res.status < 400){
        dispatch(onDeleteLetter({message: res.data.message}))
        if(callBackFunc != null){
            callBackFunc()
        }
      }
    }
  return (
        <div 
        className="modal fade show" 
        id="basicModal" 
        tabIndex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.3)",
          overflowY: 'auto'
        }}
     >
  <div style={{overflowY: 'auto'}} className="modal-dialog modal-dialog-centered modal-md" role="document">
    <div className="modal-content">
        <div className="modal-header px-4">
          <h5 className="modal-title" id="exampleModalCenterTitle">Delete Confirmation</h5>
          <button 
            type="button" 
            className="close" 
            data-dismiss="modal" 
            aria-label="Close"
            onClick={()=>{closeModal()}}
        >
          <span aria-hidden="true">×</span>
        </button>
        </div>
        <div className='modal-body'>
            <div className={'px-sm-1 px-md-2 pb-2'}>
                <p style={{lineHeight: '2rem'}}>
                    Are you sure you want to delete letter sent 
                    {''} {adjective} <b>{email}</b> {subject && <>with subject <b>{subject}</b></>}?
                </p>
            </div>
        </div>
      <div className="modal-footer px-4 d-flex align-items-center">
          <button disabled={userLoading ? true : false} onClick={()=>{closeModal()}} type="button" className="btn btn-smoke" data-dismiss="modal">Cancel</button>
          <div>
          {userLoading ? 
            <Spinner/> :
            <button onClick={deleteLetter} type="button" className="btn btn-danger">Delete</button>
          }
        </div>
        </div>
    </div>
  </div>
</div>
  )
}
